import React from 'react';
import styled from 'styled-components';
import * as Yup from 'yup';
import moment from 'moment';
import { Formik, yupToFormErrors } from 'formik';
import { getTranslatedString } from 'helpers/i18n';
import DueDate from './fields/DueDate';
import Spacer from 'components/ui/Spacer';

const StyledTitle = styled.span`
  font-size: 18px;
  font-family: 'Circular-Bold';
`;

const StyledText = styled.p`
  font-size: 14px;
`;

const ScheduleBatchForm = ({ formName, formData, handleSubmit }) => {
  const validateForm = async (values) => {
    const requiredErrorVerbiage = getTranslatedString('required');
    let validationSchema = {
      post_at: Yup.date().required(requiredErrorVerbiage),
    };
    const schema = Yup.object().shape(validationSchema);
    return schema.validate(values, { abortEarly: false }).catch((error) => {
      throw yupToFormErrors(error);
    });
  };

  const initialValues = {
    post_at: (formData.post_at && moment(formData.post_at)) || undefined,
  };

  return (
    <Formik initialValues={initialValues} onSubmit={handleSubmit} validate={validateForm}>
      {({ handleSubmit, ...rest }) => (
        <form id={formName} onSubmit={handleSubmit}>
          <DueDate {...rest} />
          <Spacer mb={0.5}>
            <StyledTitle>
              {getTranslatedString('landlordPortal.batches.schedule.howDueDateWorksTitle')}
            </StyledTitle>
            <StyledText>
              {getTranslatedString('landlordPortal.batches.schedule.howDueDateWorksBody')}
            </StyledText>
          </Spacer>
          {/* TODO: Once we figure out the trailing days for payments. Uncomment and finish this component */}
          {/* <TrailingDateInfo /> */}
        </form>
      )}
    </Formik>
  );
};

export default ScheduleBatchForm;
